import { useEffect } from 'react'

// usePageTitle
// ------------
// Sets document.title for authenticated app pages. Cleans up after
// itself on unmount so navigating away doesn't leave a stale title.
//
// Usage:
//   usePageTitle('Dashboard')   ->  "Dashboard | Receipt Chaser"
//   usePageTitle('Acme Ltd')    ->  "Acme Ltd | Receipt Chaser"
//
// Why not use the SEO component?
//   SEO is for public marketing pages: canonical URLs, meta descriptions,
//   OG tags, JSON-LD. App pages are behind auth and shouldn't be indexed.
//   A plain document.title is the right tool here.

const SUFFIX = 'Receipt Chaser'

export default function usePageTitle(title) {
  useEffect(() => {
    const previous = document.title
    document.title = title ? `${title} | ${SUFFIX}` : SUFFIX
    return () => { document.title = previous }
  }, [title])
}
